import React, { useEffect, useRef } from 'react';
import { ytReady, ytOrigin } from '../hooks/ytApi';

/**
 * One video, rebuilt on every id change. loadVideoById does not reliably reset
 * a player whose queue came from playerVars.list, so a fresh instance is the
 * only dependable way to switch.
 */
const YouTubePlayer = ({
  videoId,
  title,
  autoplay
}) => {
  const mountRef = useRef(null);
  useEffect(() => {
    if (!videoId) return undefined;
    const mount = mountRef.current;
    let alive = true;
    let player = null;
    ytReady(() => {
      if (!alive || !mount) return;
      mount.innerHTML = '';
      const host = document.createElement('div');
      host.style.width = '100%';
      host.style.height = '100%';
      mount.appendChild(host);
      player = new window.YT.Player(host, {
        width: '100%',
        height: '100%',
        host: 'https://www.youtube-nocookie.com',
        videoId,
        playerVars: {
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          ...(autoplay ? {
            autoplay: 1
          } : {}),
          ...ytOrigin()
        },
        events: autoplay ? {
          // Plays with sound: the client tapped a track, so the browser
          // has the activation unmuted playback needs.
          onReady: e => {
            e.target.unMute();
            e.target.playVideo();
          }
        } : {}
      });
    });
    return () => {
      alive = false;
      if (player) {
        try {
          player.destroy();
        } catch (e) {
          /* already gone */
        }
      }
      if (mount) mount.innerHTML = '';
    };
  }, [videoId, autoplay]);
  return React.createElement("div", {
    ref: mountRef,
    className: "cp-playermount",
    title: title
  });
};
export default YouTubePlayer;
